import { render } from "./PreviewSop.vue?vue&type=template&id=2c27e70e"
import script from "./PreviewSop.vue?vue&type=script&lang=js"
export * from "./PreviewSop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__